import { withStyles } from "@material-ui/core/styles";
import LayoutBO from "./LayoutBO.container";
import styles from "./styles";

export default withStyles(styles)(LayoutBO);
